module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluate"
  }, [_c('a', [_c('em', {
    style: ({
      width: _vm.star1
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star2
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star3
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star4
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star5
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3c0c22f8","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentStars.vue
// module id = 428
// module chunks = 7